import React from 'react';

import { dayjs } from '@/utils/dateTimeUtils';

/**
 * @description This widget is to show the date and time in a formatted value from unix timestamp.
 *
 * @author  Hemant Kumar Goyal <@hemantkumar.goyal>
 *
 * @param {object} props
 * @param {string} props.format Display format of date time. Valid values can be found here: https://day.js.org/docs/en/display/format#list-of-all-available-formats
 * @param {string | number} props.children Unix or valid datetime instance.
 * @param {string} [props.className] Any additional classname for stylling
 * @param {string} [props.style] Any inline stylling that needs to be appended
 *
 * @returns {React.ReactElement}
 */

const DateTime = (props) => {
	const { className, format, style = {}, children } = props;

	const getDateTime = () => {
		if (dayjs(children).isValid()) {
			return dayjs(children).format(format);
		}

		return children;
	};

	return (
		<time className={className} style={style}>
			{getDateTime()}
		</time>
	);
};

export default DateTime;
